import React, { createContext, useContext, useState, useEffect } from 'react';
import firebase from '../firebaseConfig';

const AdminViewContext = createContext();

export const useAdminView = () => {
    const context = useContext(AdminViewContext);
    if (!context) {
        throw new Error('useAdminView must be used within an AdminViewProvider');
    }
    return context;
};

export const AdminViewProvider = ({ children }) => {
    const [isAdminView, setIsAdminView] = useState(false);
    const [viewedUser, setViewedUser] = useState(null);
    const [adminId, setAdminId] = useState(null);

    useEffect(() => {
        // Vérifier si on est en mode admin au chargement
        const adminViewingAs = localStorage.getItem('adminViewingAs');
        const storedAdminId = localStorage.getItem('adminId');
        
        if (adminViewingAs && storedAdminId) {
            setIsAdminView(true);
            setAdminId(storedAdminId);
            
            // Charger les données de l'utilisateur visualisé
            loadViewedUser(adminViewingAs);
        }
    }, []);

    const loadViewedUser = async (userId) => {
        try {
            const userDoc = await firebase.firestore().collection('users').doc(userId).get();
            if (userDoc.exists) {
                const userData = userDoc.data();
                setViewedUser({ ...userData, uid: userId });
            }
        } catch (error) {
            console.error('Error loading viewed user:', error);
        }
    };

    const enterAdminView = async (userId, currentAdminId) => {
        localStorage.setItem('adminViewingAs', userId);
        localStorage.setItem('adminId', currentAdminId);
        setIsAdminView(true);
        setAdminId(currentAdminId);
        await loadViewedUser(userId);
    };

    const exitAdminView = () => {
        localStorage.removeItem('adminViewingAs');
        localStorage.removeItem('adminId');
        setIsAdminView(false);
        setViewedUser(null);
        setAdminId(null);
    };

    const value = {
        isAdminView,
        viewedUser,
        adminId,
        enterAdminView,
        exitAdminView,
        loadViewedUser
    };

    return (
        <AdminViewContext.Provider value={value}>
            {children}
        </AdminViewContext.Provider>
    );
};
